import React, { useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import { Card, Table } from 'antd'
import { actions } from '../../../../store/reducers/assignment.reducer'
import { useParams } from 'react-router'
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle'
import { PATTERN_TYPES_VALUE_TO_NAME } from '../../../../constants/pattern-types'
import assignmentSelectors from '../../../../store/selectors/assignment.selectors'
import PatternIcon from '../../../../components/common/PatternIcon'

const PatternReportSection = ({ assignment, patternsReportData, fetchPatternsReport }) => {
    const modelHasMba = useSelector(assignmentSelectors.modelHasMba)

    useDocumentTitle(`${assignment.assignment_name || ''} Patterns`)

    const { token, layerId } = useParams()
    const [isWaitingForPatternsReport, setIsWaitingForPatternsReport] = useState(false)

    useEffect(() => {
        ;(async () => {
            setIsWaitingForPatternsReport(true)
            await fetchPatternsReport(token, layerId)
            setIsWaitingForPatternsReport(false)
        })()
    }, [token, layerId])

    const instantFeedbackMetricsColumns = [
        {
            title: '# Hits',
            dataIndex: 'numOfHits',
            key: 'numOfHits',
            width: '8%',
            sorter: (a, b) => a.numOfHits - b.numOfHits,
        },
        {
            title: '# Views',
            dataIndex: 'numOfViews',
            key: 'numOfViews',
            width: '6%',
            sorter: (a, b) => a.numOfViews - b.numOfViews,
        },
        {
            title: 'Grade delta',
            dataIndex: 'gradeDelta',
            key: 'gradeDelta',
            width: '6%',
            sorter: (a, b) => a.gradeDelta - b.gradeDelta,
        },
        {
            title: '# Helped',
            dataIndex: 'helped',
            key: 'helped',
            width: '6%',
            sorter: (a, b) => a.helped - b.helped,
        },
        {
            title: "# Didn't help",
            dataIndex: 'notHelped',
            key: 'notHelped',
            width: '6%',
            sorter: (a, b) => a.notHelped - b.notHelped,
        },
    ]

    const patternTableColumns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: '4%',
            render: (id, record) => <PatternIcon id={id} type={record.type} colorId={record.colorId} />,
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: '10%',
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            width: '5%',
            render: type => PATTERN_TYPES_VALUE_TO_NAME[type],
        },
        {
            title: '# Files',
            dataIndex: 'numOfFiles',
            key: 'numOfFiles',
            width: '6%',
        },
        {
            title: 'Avg. lines',
            dataIndex: 'averageLines',
            key: 'averageLines',
            width: '6%',
        },
        ...(modelHasMba ? instantFeedbackMetricsColumns : []),
        {
            title: 'Groups',
            dataIndex: 'groups',
            key: 'groups',
            width: '20%',
            render: clusterNames => (
                <>
                    {clusterNames.split(', ').map((clusterName, index) => (
                        <p key={index}>{clusterName}</p>
                    ))}
                </>
            ),
        },
    ]

    const parsedPatternsReportData = []
    patternsReportData?.map(pattern => {
        parsedPatternsReportData.push({
            key: pattern.id,
            id: pattern.id,
            name: pattern.name,
            type: pattern.type,
            query: pattern.query,
            numOfFiles: pattern.files_count,
            averageLines: parseFloat(pattern.average_line_count?.toFixed(2)),
            numOfHits: pattern.pattern_hits,
            numOfViews: pattern.pattern_acted_on,
            gradeDelta: pattern.pattern_grade_delta,
            helped: pattern.pattern_helped,
            notHelped: pattern.pattern_did_not_help,
            groups: pattern.groups,
            colorId: pattern.color_id,
        })
    })

    return (
        <div className='patterns-report-section'>
            <Card title='Patterns Report'>
                <Table
                    columns={patternTableColumns}
                    rowClassName={record => record.className}
                    dataSource={parsedPatternsReportData}
                    pagination={false}
                    loading={isWaitingForPatternsReport}
                    scroll={{ x: true }}
                />
            </Card>
        </div>
    )
}

const mapState = ({ assignment }) => {
    return {
        assignment: assignment.assignment,
        patternsReportData: assignment.patternsReportData,
    }
}

const mapDispatch = dispatch => {
    return {
        fetchPatternsReport: (token, layerId) => {
            return dispatch(actions.fetchPatternsReport(token, layerId))
        },
    }
}

export default connect(mapState, mapDispatch)(PatternReportSection)
